var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header_box mr200 ml200 mt60 pl30 pr30 pb45"},[_c('div',{staticClass:"fs32 fw-600 w384 text-center team_title",staticStyle:{"margin":"0 auto"}},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"text-center flex col-center row-center h-max color9D fs24 mt72"},[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }